import moment from 'moment';

class OtherDirectCostsItemModalController {
  constructor($http, $uibModalInstance, $rootScope, $scope, $timeout, toastr, TravelExpenseService, existingExpense) {
    'ngInject';

    this.$http = $http;
    this.$uibModalInstance = $uibModalInstance;
    this.$rootScope = $rootScope;
    this.$scope = $scope;
    this.$timeout = $timeout;
    this.toastr = toastr;
    this.travelExpenseService = TravelExpenseService;

    this.categories = this.travelExpenseService.getOtherDirectCostCategories();

    this.editMode = !!existingExpense;
    this.originalExpense = existingExpense || null;

    this.item = {
      category: '',
      customCategory: '',
      description: '',
      amount: null,
      dateNeeded: null,
      documentationLink: ''
    };

    this.costDisplay = '';
    this.selectedFileName = null;
    this.estimateBasisFile = null;
    this.existingAttachmentName = null;

    if (this.editMode) {
      const type = existingExpense.type || '';
      const isKnownCategory = this.categories.indexOf(type) !== -1;

      this.item = {
        category: isKnownCategory ? type : 'Other',
        customCategory: isKnownCategory ? '' : type,
        description: existingExpense.description,
        amount: existingExpense.amount,
        dateNeeded: existingExpense.dateNeeded ? moment(existingExpense.dateNeeded).toDate() : null,
        documentationLink: existingExpense.documentationLink || ''
      };

      this.estimateBasisFile = existingExpense.estimateBasisFile || null;
      this.existingAttachmentName = this.travelExpenseService.getEstimateBasisLabel(existingExpense) || null;
      this.selectedFileName = existingExpense.estimateBasisFile ? existingExpense.estimateBasisFileName : null;
      this.formatCostDisplay();
    }

    this.$timeout(() => this.initFileSelector());
  }

  getModalTitle() {
    return this.editMode ? 'Edit Other Direct Cost' : 'Add Other Direct Cost';
  }

  getSubmitLabel() {
    return this.editMode ? 'Save Item' : 'Add Item';
  }

  isOtherCategory() {
    return this.item.category === 'Other';
  }

  hasAttachment() {
    return !!(this.estimateBasisFile || this.existingAttachmentName);
  }

  initFileSelector() {
    this.fileSelector = document.getElementById('other-direct-costs-item-file');

    if (!this.fileSelector) {
      return;
    }

    this.fileSelector.addEventListener('change', () => {
      const file = this.fileSelector.files && this.fileSelector.files[0];

      this.$scope.$apply(() => {
        this.estimateBasisFile = file || null;
        this.selectedFileName = file ? file.name : null;
      });
    });
  }

  onCostFocus() {
    if (this.item.amount != null && !isNaN(this.item.amount)) {
      this.costDisplay = String(this.item.amount);
    }
  }

  onCostBlur() {
    this.parseCostDisplay();
    this.formatCostDisplay();
  }

  parseCostDisplay() {
    const raw = String(this.costDisplay || '').replace(/[^0-9.-]/g, '');
    const parsed = parseFloat(raw);
    this.item.amount = isNaN(parsed) ? null : Math.round(parsed * 100) / 100;
  }

  formatCostDisplay() {
    if (this.item.amount == null || isNaN(this.item.amount)) {
      this.costDisplay = '';
      return;
    }

    this.costDisplay = this.travelExpenseService.formatNumber(this.item.amount);
  }

  clearSelectedFile() {
    this.estimateBasisFile = null;
    this.selectedFileName = null;

    if (this.fileSelector) {
      this.fileSelector.value = '';
    }
  }

  resolveCategory() {
    if (this.isOtherCategory()) {
      return (this.item.customCategory || '').trim();
    }

    return this.item.category;
  }

  save() {
    if (!this.item.category) {
      this.toastr.warning('Select what you would like to purchase.', 'Incomplete');
      return;
    }

    const category = this.resolveCategory();
    if (!category) {
      this.toastr.warning('Enter what you would like to purchase.', 'Incomplete');
      return;
    }

    if (!this.item.description || !this.item.description.trim()) {
      this.toastr.warning('Explain why you need this.', 'Incomplete');
      return;
    }

    this.parseCostDisplay();
    if (this.item.amount == null || isNaN(this.item.amount) || this.item.amount <= 0) {
      this.toastr.warning('Enter a valid cost greater than zero.', 'Incomplete');
      return;
    }

    if (!this.item.dateNeeded) {
      this.toastr.warning('Enter the date you need this by.', 'Incomplete');
      return;
    }

    const expenseToSave = {
      itinerary: false,
      type: category,
      description: this.item.description.trim(),
      amount: this.item.amount,
      dateNeeded: moment(this.item.dateNeeded).format('YYYY-MM-DD'),
      documentationLink: (this.item.documentationLink || '').trim(),
      estimateBasisFile: this.estimateBasisFile,
      estimateBasisFileName: this.selectedFileName || this.existingAttachmentName
    };

    if (this.editMode) {
      this.$uibModalInstance.updateItemInReport(this.originalExpense, expenseToSave);
    } else {
      this.$uibModalInstance.addItemToReport(expenseToSave);
    }

    this.$uibModalInstance.dismiss('success');
  }

  cancel() {
    this.$uibModalInstance.dismiss('cancel');
  }
}

export default OtherDirectCostsItemModalController;



// WEBPACK FOOTER //
// ./client/pages/expenses/modals/other-direct-costs-item/other-direct-costs-item.controller.js